import { useTranslation } from 'react-i18next'
import { cartUI } from '../../../shared/store/cart.store.js'

interface Props {
  itemCount: number
}

export default function CartIcon({ itemCount }: Props) {
  const { t } = useTranslation()
  const hasItems = itemCount > 0

  return (
    <button
      type="button"
      className="storefront-cart-icon"
      onClick={() => cartUI.open()}
      aria-label={t('cart.cart')}
    >
      🛒
      {hasItems && <span className="storefront-cart-badge">{itemCount}</span>}
    </button>
  )
}